import React from "react";
import { Button, Typography } from "antd";
import {
  MenuOutlined,
  UserOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";

//import icons
import LogoIcon from "../../assets/icons/LogoIcon";

//import component
import UserOptions from "../UserOptions";
import config from '../../config';



//import functions
import checkSuperAdminToken from "../../utils/checkSuperAdminToken";

import {
    StyledHeader,
    StyledHeaderRow,
    StyledSidebarControlWrapper,
    StyledColumn,
    StyledSwitchColumn,
    StyledButton,
    StyledAvatar,
    Username,
    SpaceColumn,
    UserOptionColWrapper,
    UserDetailsWrapper,
    UserTextStack,
    UserType,
    VersionText,
} from "./styles";
import { useAuthenticatedSession } from "../../context/AuthProvider";

const { Text } = Typography;

const MainHeader = ({ userDetails, changeSidebarCollapseState }) => {
  const { user } = useAuthenticatedSession();
  const releaseVersion = config.releaseVersion || 'unknown';

  const onSidebarCollapseStateChange = () => {
    changeSidebarCollapseState((previousSidebarState) => {
      return !previousSidebarState;
    });
  };

  const switchButtonClick = () => {
    const superAdminToken = window.localStorage.getItem("superAdminToken");
    const superAdminEmail = window.localStorage.getItem("superAdminEmail");
    const superAdminType = window.localStorage.getItem("superAdminType");

    window.localStorage.setItem("userToken", superAdminToken);
    window.localStorage.setItem("userEmail", superAdminEmail);
    window.localStorage.setItem("type", superAdminType);
    window.localStorage.removeItem("superAdminToken");
    window.localStorage.removeItem("superAdminEmail");
    window.localStorage.removeItem("superAdminType");

    // BASE_URL-aware ('/' legacy, '/admin/' on the IDP path) — a bare "/..." would escape the SPA.
    window.location.href = `${import.meta.env.BASE_URL}dictionary/users`;
  };

  return (
    <StyledHeader>
      <StyledHeaderRow>
        <StyledSidebarControlWrapper>
          <StyledButton
            icon={<MenuOutlined />}
            size="large"
            onClick={onSidebarCollapseStateChange}
          />
        </StyledSidebarControlWrapper>
        <StyledColumn>
          <LogoIcon width="172px" height="72px" />
          <VersionText>{releaseVersion}</VersionText>
        </StyledColumn>
        <SpaceColumn />

        {checkSuperAdminToken() && (
          <StyledSwitchColumn>
            <Button
              type="primary"
              icon={<UserSwitchOutlined />}
              onClick={() => switchButtonClick()}
            >
              <Text>Switch</Text>
            </Button>
          </StyledSwitchColumn>
        )}

        <UserOptionColWrapper>
          <UserOptions userDetails={userDetails}>
            <UserDetailsWrapper>
              <StyledAvatar icon={<UserOutlined />} />
              <UserTextStack>
                <Username>{user.email}</Username>
                <UserType>{user?.type}</UserType>
              </UserTextStack>
            </UserDetailsWrapper>
          </UserOptions>
        </UserOptionColWrapper>
      </StyledHeaderRow>
    </StyledHeader>
  );
};

export default MainHeader;
